import _ from 'lodash';

export * as appFormUtil from './appFormUtil';
export * as appValidationUtil from './appValidationUtil';
export * as authUtil from './authUtil';
export * as ApiRequestTable from './components/ApiRequestTable/ApiRequestTable';
export * as ApprovalStatusToggle from './components/ApprovalStatusToggle';
export * as ApprovalTypeChip from './components/ApprovalTypeChip';
export * as AuthRedirector from './components/AuthRedirector/AuthRedirector';
export * as ColorPickerField from './components/ColorPickerField/ColorPickerField';
export * as CustomSpeedDial from './components/CustomSpeedDial/CustomSpeedDial';
export * as DeliveryStatusChip from './components/DeliveryStatusChip';
export * as ExportAsnModal from './components/ExportAsnModal/ExportAsnModal';
export * as FormattedCode from './components/FormattedCode';
export * as FormModal from './components/FormModal/FormModal';
export * as ImportOrdersModal from './components/ImportOrdersModal/ImportOrdersModal';
export * as InviteUserModal from './components/InviteUserModal/InviteUserModal';
export * as LabelledText from './components/LabelledText/LabelledText';
export * as layout from './components/layout';
export * as LogoField from './components/LogoField/LogoField';
export * as NetSuiteRecordChip from './components/NetSuiteRecordChip/NetSuiteRecordChip';
export * as NetSuiteRecordLink from './components/NetSuiteRecordLink/NetSuiteRecordLink';
export * as OrderAndReturnToggle from './components/OrderAndReturnToggle/OrderAndReturnToggle';
export * as OrderStatusChip from './components/OrderStatusChip';
export * as OverallOrderStatusChip from './components/OverallOrderStatusChip/OverallOrderStatusChip';
export * as QueueTabBar from './components/QueueTabBar/QueueTabBar';
export * as SelectItemsModal from './components/SelectItemsModal/SelectItemsModal';
export * as SingleOrderRecordNavigator from './components/SingleOrderRecordNavigator/SingleOrderRecordNavigator';
export * as SpinningInProgressIndicator from './components/SpinningInProgressIndicator/SpinningInProgressIndicator';
export * as StatusCheckIcon from './components/StatusCheckIcon';
export * as StoreFeatureToggle from './components/StoreFeatureToggle/StoreFeatureToggle';
export * as StoreThemeProvider from './components/StoreThemeProvider/StoreThemeProvider';
export * as SyncedDataText from './components/SyncedDataText/SyncedDataText';
export * as SystemAlert from './components/SystemAlert/SystemAlert';
export * as TabBarContainer from './components/TabBarContainer/TabBarContainer';
export * as Timeline from './components/Timeline/Timeline';
export * as TransferList from './components/TransferList/TransferList';
export * as currencyUtil from './currencyUtil';
export * as dialogUtil from './dialogUtil';
export * as gqlCacheUtil from './gqlCacheUtil';
export * as mockDataUtil from './mockDataUtil';
export * as permissionUtil from './permissionsUtil/usePermissions';
export * as referralUtil from './referralUtil';
export { routeDirectory } from './routeDirectory';
export * as stepUtil from './stepUtil';
export * as tableUtil from './tableUtil';
export * as unitConversionUtil from './unitConversionUtil';
export { useTabSearchParams } from './useTabSearchParams';
export * as shopifyAuthUtil from './shopifyAuthUtil';



export function showNotYetImplemented() {
  alert("Not yet implemented");
}



export function makeNameAbbreviation(name: string) {
  const words = _.split(name, /\s+/);

  const first = _.map(words, word => _.first(word));
  return _.join(first, '');
}



export const isProd = process.env.REACT_APP_ENV_NAME === 'prod' || process.env.REACT_APP_ENV_NAME === 'devAndrew';
